<div class="overlay view-participants">

    <div class="overlay-header">
        <h2>View Participants</h2>
        <div class="close-btn">
            <button mat-icon-button mat-dialog-close>
                <f-icon [iconConfig]="iconConfig"></f-icon>
            </button>
        </div>
    </div>
    <div class="section-divider"></div>
    <section class="error-wrapper hide">
        <f-alert variant="error">There was a problem loading. <button class="Try again"> Try again</button>
        </f-alert>
    </section>
   

    <div class="overlay-body">
        <div class="container">
            <div class="row">
                <div class="col-md-6 left-panel">
                    <div class="row row-bottom-space">
                        <div class="col-md-12">
                            <div class="data-label">Title</div>
                            <div class="data-value">ROI - Release of Information</div>
                        </div>
                    </div>
                    <div class="row row-bottom-space">
                        <div class="col-md-6 ">
                            <div class="data-label">Start</div>
                            <div class="data-value">Jun-04-2023</div>
                        </div>
                        <div class="col-md-6">
                            <div class="data-label">End</div>
                            <div class="data-value">May-04-2023</div>
                        </div>
                    </div>
                    <div class="row row-bottom-space">
                        <div class="col-md-6">
                            <div class="data-label">Created</div>
                            <div class="data-value">May-04-2023</div>
                        </div>
                        <div class="col-md-6">
                            <div class="data-label">Created By</div>
                            <div class="data-value">John S</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="data-label">Details</div>
                            <div class="data-value">The person is an authorized person</div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 right-panel">

                    <div class="participants-data">

                        <app-alight-table class="current-table" [dataSource]="dataSource" [totalRecords]="totalRecords"
                            [gridColumns]="currentColumns1" [tableName]="'currentTable'" [rowPerPage]="10"
                            (rowSelection)="rowSelection($event)" [isShowButtons]="false"></app-alight-table>

                    </div>
                </div>
            </div>

        </div>
    </div>








</div>